import React, { forwardRef } from 'react';
import uuid from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    const id = uuid.v4();

    return (
        <SvgIcon ref={ref} {...props}>
            <g clipPath={`url(#${id})`}>
                <path d='M13.8947 1.89474C13.8947 1.39222 13.6951 0.910288 13.3398 0.554956C12.9844 0.199624 12.5025 0 12 0C11.4975 0 11.0156 0.199624 10.6602 0.554956C10.3049 0.910288 10.1053 1.39222 10.1053 1.89474V10.1053H1.89474C1.39222 10.1053 0.910288 10.3049 0.554956 10.6602C0.199624 11.0156 0 11.4975 0 12C0 12.5025 0.199624 12.9844 0.554956 13.3398C0.910288 13.6951 1.39222 13.8947 1.89474 13.8947H10.1053V22.1053C10.1053 22.6078 10.3049 23.0897 10.6602 23.445C11.0156 23.8004 11.4975 24 12 24C12.5025 24 12.9844 23.8004 13.3398 23.445C13.6951 23.0897 13.8947 22.6078 13.8947 22.1053V13.8947H22.1053C22.6078 13.8947 23.0897 13.6951 23.445 13.3398C23.8004 12.9844 24 12.5025 24 12C24 11.4975 23.8004 11.0156 23.445 10.6602C23.0897 10.3049 22.6078 10.1053 22.1053 10.1053H13.8947V1.89474Z' />
            </g>
            <defs>
                <clipPath id={id}>
                    <rect width='24' height='24' />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});
